import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'CONFERENCE_CREATION_PAGE.title',
    defaultMessage: 'Edit conference call',
  },
  edit: {
    id: 'CONFERENCE_CREATION_PAGE.edit',
    defaultMessage: 'Save',
  },
  editFailure: {
    id: 'CONFERENCE_CREATION_PAGE.editFailure',
    defaultMessage: 'Error while updating the transcript. Please try again later.',
  },
  editSuccess: {
    id: 'CONFERENCE_CREATION_PAGE.editSuccess',
    defaultMessage: 'Transcript was updated successfully.',
  },
});



// WEBPACK FOOTER //
// ./components/pages/ConferenceEditPage/messages.js